/**
 * 万里汇（WorldFirst）合作落地页 —— 文案常量
 *
 * 需求来源：docs/万里汇合作落地页/万里汇合作落地页-提示词.md 第1次提交（任务单 DEV-124229，父单 DEV-124227）；
 *           视觉基准 docs/万里汇合作落地页/万里汇合作页面.html；词条清单见 docs/万里汇合作落地页/工作台-文案与key清单.md。
 *
 * 注意事项：
 * 1. 本页 8 大区块：HERO(Hero Banner) / BONUS($100 奖励) / STEPS(三步领取) / BUSINESS(全球收付款) /
 *    MULTI(多币种账户 6 卡) / EVENTS(线下活动轮播) / FAQ(9 条手风琴) / CTA(底部 CTA)。
 *
 * 2. 【i18n】所有可见文案统一走 `i18next.t('worldfirst-{区块}-{描述}', '英文源')`，**key 全小写**
 *    （翻译中心上报要求）；词库落盘 public/lang/local/worldfirst.json，pageId=worldfirst
 *    （见 public/lang/router.json）。
 *    **key 必须是字面量、且紧跟在 `i18next.t(` 之后** —— @cckj/i18n-util 的 extract 是**文本扫描**，
 *    用 `new RegExp("i18next\\.t\\(\\s*['\"`]<key>['\"`]")` 逐个词库 key 去代码里找。
 *    所以这里**不能**包一层 `t(key, def)` 之类的转发函数，也不能用变量 key —— 那样扫不到就漏报。
 *    实证：cjBusinessTravel 曾把 2 条封在 dyn(key,...) 里，429 个词条只上报了 427 个。
 *    该约束由单测 CASE-N1 用同一条正则逐 key 复核。
 *
 * 3. 【句中强调 —— 强调词直接内嵌 <strong> 写在词条里】
 *    渲染侧由 components/EmphasisText.jsx 把 <strong> **白名单解析成 React 元素**。
 *    曾短暂用过 `dangerouslySetInnerHTML`，但它有个致命问题：**React 在 hydration 阶段不校验、
 *    也不回填 innerHTML**，而本页 SSR 出英文、客户端才拿到译文 —— 结果切到中文时那些位置永远停在英文
 *    （实测 8 处普通文本节点全部变中文、7 处 innerHTML 全部没变，相关性 100%）。
 *    解析成 React 子节点后走的是普通渲染路径，顺带也消掉了 innerHTML 的 XSS 面。
 *
 *    这里曾走过一版**错误**方案：词条用 `%em%` 占位、被强调的片段另立 `-em` key，渲染时拼装。
 *    260818 实测把它否掉了，两个独立的致命问题：
 *      · 占位符活不过翻译管线：`%x%` 完好率 17.3%（19 语种 608 样本），与"完全不受保护"的
 *        `{x}` 的 16.7% 无统计差别 —— 被首字母大写成 `%Em%`、拆断、挪位、整个吞掉。
 *        对照组 `{{x}}` 是 99.6%、`<strong>/<code>/<a href>` 族是 100.0%（374 样本，
 *        且确认不是"没翻译"：17 个语种里 16 个译文与英文源不同）。
 *      · 片段脱离上下文单独送翻，60.1% 不可用（47 个片段 key × 16 语种 = 752 样本）：
 *        "20+" 的 `+` 号 128/128 全丢（营销口径从"20 多种"变成"20 种"）、金额与日期被改、
 *        专有名词被译成普通名词、后台按钮字面量被翻译（用户照译文在后台找不到那个按钮）。
 *    改为内嵌 <strong> 后两个问题一并消失：标记走的是实测 100% 存活的标签族，
 *    强调词回到句子里有完整上下文。
 *
 *    当初"词库必须纯文本"的前提也是错的 —— 那个结论只对照了 cjBusinessTravel.json 一个文件，
 *    全仓实测有 19 条词条含 HTML 标签，是既有做法。
 *
 *    【约束】词条里只放 `<strong>`，**不要带 class 属性**：带 class 的那一族实测属性保留率
 *    只有 50.6%，把配色寄托在译文里等于把样式交给机翻。需要特殊配色的（全页仅 FAQ Q01 第 2 段
 *    那处粉色）用不参与翻译的 `pClass` 字段挂到外层元素上，见该条目就近注释。
 *
 * 4. 【同构安全】CommonJS，禁止 import/export 与 fs/path；i18next 取词器复用 mcpLanding/i18nText，
 *    SSR/未初始化时 fallback.t 直接返回第二个参数（英文源），故 SSR 与 CSR 文案一致。
 *
 * 5. 【原型缺陷修正】按 D7（用户 2026-08-17 拍板"全部修正"）逐处修正，改动点在下方对应位置就近注释：
 *    Hero 标题字面空格 / affiliates,Zyla 缺空格 / §5 卡4 标题与卡1 重复 / note 文案重复两处。
 *
 * 6. 外链为固定值不做翻译，集中在 LINKS，其中 affiliate_id 是分成归属凭据，一个字符都不能改。
 *
 * 7. 【品牌名走 {{}} 插值、不进翻译】WorldFirst / World Account / World Card / World Direct /
 *    CJdropshipping 一律以 `{{wf}}` 这类占位写在词条里，取值见下方 BRAND 常量（含实测数据与原因）。
 *    单测 CASE-N5 卡三件事：只许 {{ }} 形态、变量须在 BRAND 里声明、词条里不得再出现品牌字面量。
 */
'use strict';

var createImg = require('./images').createImg;

/**
 * 原型固定外链。
 * 【注意】LINK_WF_REGISTER 带的 affiliate_id=QD02299 是本次 CJ × WorldFirst 合作的**分成归属凭据**，
 *        改动或丢参会直接导致这次合作的分成归不到 CJ 名下；单测 CASE-L1/L2 对全 URL 做逐字全等断言。
 */
var LINKS = {
  register: 'https://portal.worldfirst.com/register?affiliate_id=QD02299',
  wallet: 'https://cjdropshipping.com/mine/wallet',
  // 需求 260818：底部 CTA 的 "Contact Us" 点击后新窗口打开 WhatsApp 客服（业务方给定）。
  //   原型此处是 href="#" 占位（点了只会跳回页首），此前按 D5 暂指向条款锚点、不擅自猜地址，现已落定。
  //   wa.me 是 WhatsApp 官方短链，路径段就是国际区号+号码（1 = 美国，5715806890），不带 + 和分隔符。
  contact: 'https://wa.me/15715806890',
  /*
   * 活动条款 PDF（业务方给定），全页 3 处 T&C 入口共用，一律新窗口打开：
   *   §2 Bonus 奖励卡的 "View T&C"（.cjwf-bonus__reward-link）
   *   §3 Step3 卡的 "View T&C" 按钮（.wf-step-button）
   *   §3 区块底部的 "Terms & Conditions"（.wf-steps-terms）
   *
   * 【260818 已删除 LINKS.terms】此前上面三处里的前两处指向 `#worldfirst-terms` 占位锚点，
   * 而全页**根本不存在**这个 id —— 点了只会跳回页首，是条死链（原型自身遗留，按 D5 一直挂着待业务方给定）。
   * 现统一到本条，占位符不再保留：留着它就还会有人接着引用，而它看起来又"像是能用"。
   * 同时删掉了 STEPS.termsUrl 那个字段 —— 它引用的也是这个占位符，且 Steps.jsx 用的是 termsPdfUrl，
   * 它自始至终没被渲染过。
   */
  termsPdf: 'https://cjec.cjdropshipping.com/wp-content/uploads/2026/08/CJ-Dropshipping-x-WorldFirst-Promotion-Terms-and-Conditions-.pdf',
};

/**
 * 取本页全部展示常量（每次调用重新取词，语言切换后文案随之更新）。
 * @param {string} [cdnHost] CDN 域名，用于拼图片路径
 * @returns {Object} 8 大区块常量
 */
/**
 * 品牌名/产品名，作为 {{}} 插值取值传给 i18next —— **不进翻译中心**。
 *
 * 【为什么】品牌名放在词条正文里会被当普通词翻译。260818 实测 16 语种：
 *   World Account 改写率 96.2%、World Card 81.2%、WorldFirst 55.8%、CJdropshipping 40.4%。
 *   zh 把 WorldFirst 译成「world第一」；th/ky/tk/uz 整个意译掉、页面上再也不出现品牌名；
 *   kk 混进 FirstGenericName 系统串；ar 拼成 Worldvirst。
 *   这是**合作方品牌在落地页上被写错名字**，且品牌名没有任何本地化余地 —— 所有语种都必须原样。
 * 而 {{ }} 是全仓通用形态、被管线保护（实测完好率 99.6%，4322 样本），故改走插值。
 *
 * 【一个对象喂所有调用】取值恒定，用不到的 key 传过去 i18next 也不会有副作用，
 * 故所有含占位的 t() 调用统一传本对象，避免每处手写取值表而漏项/写错。
 *
 * 【不需要 escapeValue:false】这几个值都不含 & < > 等需转义字符；
 * 若将来要把含 & 的字面量（如后台按钮名 Send & Withdraw）也做成插值，那时才需要逐调用关闭转义。
 */
var BRAND = {
  wf: 'WorldFirst',
  wa: 'World Account',
  wc: 'World Card',
  wd: 'World Direct',
  cj: 'CJdropshipping',
};

function getConstants(cdnHost) {
  var i18next = require('../mcpLanding/i18nText').getI18next();
  var img = createImg(cdnHost);

  return {
    LINKS: LINKS,

    // ========== §1 Hero（cjwf-dark-banner）==========
    HERO: {
      // 【纠正】原型 L1935 在 </span> 与 'Got You Covered' 之间烤进了 8 个字面空格；
      //         此处按 line1 / em / line2 三段拆开，间距交给 JSX 结构与 CSS，不复刻那 8 个空格。
      titleLine1: i18next.t('worldfirst-hero-title-line1', 'Ready to Scale?'),
      titleEm: i18next.t('worldfirst-hero-title-em-v2', '{{cj}} + {{wf}}', BRAND),
      titleLine2: i18next.t('worldfirst-hero-title-line2', 'Got You Covered'),
      desc: i18next.t('worldfirst-hero-desc', 'Make Dropshipping simple, make payments seamless.'),
      benefits: [
        {
          text: i18next.t('worldfirst-hero-benefit1-v2', 'Receive funds in <strong>20+ currencies</strong> with zero fees'),
        },
        {
          text: i18next.t('worldfirst-hero-benefit2-v2', 'Get paid directly from <strong>130+ marketplaces</strong>'),
        },
        {
          text: i18next.t('worldfirst-hero-benefit3-v2', 'Send payments in <strong>100+ currencies</strong> to <strong>210+ countries/territories</strong>'),
        },
      ],
      ctaText: i18next.t('worldfirst-hero-cta-v2', 'Get Started with {{wf}}', BRAND),
      ctaUrl: LINKS.register,
      // 【纠正】原型 L2075 为 'affiliates,Zyla'，逗号后缺空格，属笔误。
      note: i18next.t('worldfirst-hero-note-v2', 'US clients are supported by {{wf}} affiliates, Zyla', BRAND),
      floatTop: {
        value: i18next.t('worldfirst-hero-float-top-value', '20+ Currencies'),
        label: i18next.t('worldfirst-hero-float-top-label', 'Multi-Currency Account'),
      },
      floatBottom: {
        value: i18next.t('worldfirst-hero-float-bottom-value', '210+ Markets'),
        label: i18next.t('worldfirst-hero-float-bottom-label', 'Global Payment Reach'),
      },
      dashboard: {
        label: i18next.t('worldfirst-hero-dashboard-label', 'Global Business Account'),
        title: i18next.t('worldfirst-hero-dashboard-title', 'Multi-Currency Balance'),
        secure: i18next.t('worldfirst-hero-dashboard-secure', 'Secure'),
        accountLabel: i18next.t('worldfirst-hero-account-label', 'Available Business Balance'),
        accountStatus: i18next.t('worldfirst-hero-account-status', 'Active'),
        // 金额/币种代码不进词库：无翻译价值，且改动会破坏视觉对齐
        balance: '$28,560.80',
        accountFoot1: i18next.t('worldfirst-hero-account-foot1', 'Global account'),
        accountFoot2: i18next.t('worldfirst-hero-account-foot2', 'Updated just now'),
        currencies: [
          { code: 'USD', value: '$12,840' },
          { code: 'EUR', value: '€8,920' },
          { code: 'GBP', value: '£5,480' },
        ],
        txnLabel: i18next.t('worldfirst-hero-txn-label', 'Payment Received'),
        txnMeta: i18next.t('worldfirst-hero-txn-meta', 'Marketplace settlement'),
        txnValue: '+$2,450.00',
        txnStatus: i18next.t('worldfirst-hero-txn-status', 'Completed'),
        feature1: i18next.t('worldfirst-hero-feature1', 'Global collections'),
        feature2: i18next.t('worldfirst-hero-feature2', 'Supplier payments'),
      },
    },

    // ========== §2 Bonus（cjwf-bonus）==========
    BONUS: {
      heading: i18next.t('worldfirst-bonus-heading-v2', '<strong>$100</strong> Exclusive Bonus for CJ Sellers'),
      cards: [
        {
          title: i18next.t('worldfirst-bonus-card1-title-v3', 'Get a $100 USD bonus when you pay CJ <strong>≥ $500</strong> via {{wf}}!', BRAND),
          imageUrl: img('bonus_pay_cj_worldfirst.png'),
        imageAlt: i18next.t('worldfirst-bonus-card1-alt-v2', 'Pay CJ using {{wf}} or {{wd}}', BRAND),
        },
        {
          title: i18next.t('worldfirst-bonus-card2-title-v3', 'Get a $100 USD bonus when your {{wc}} cumulative spending reaches <strong>≥ $500</strong>', BRAND),
          imageUrl: img('bonus_world_card_spend.png'),
        imageAlt: i18next.t('worldfirst-bonus-card2-alt-v2', '{{wf}} {{wc}} cumulative spending of 500 dollars', BRAND),
        },
      ],
      orText: i18next.t('worldfirst-bonus-or', 'OR'),
      reward: {
        title: i18next.t('worldfirst-bonus-reward-title-v3', 'Your <strong>$100 bonus</strong> goes straight to your {{wf}} account.', BRAND),
        text: i18next.t('worldfirst-bonus-reward-text', 'Complete either qualifying option above to unlock your reward.'),
        metas: [
          {
            label: i18next.t('worldfirst-bonus-meta1-label', 'Campaign Period:'),
            text: i18next.t('worldfirst-bonus-meta1-text', 'Valid through'),
            em: i18next.t('worldfirst-bonus-meta1-em', 'December 31, 2026'),
          },
          {
            label: i18next.t('worldfirst-bonus-meta2-label', 'Limited Availability:'),
            text: i18next.t('worldfirst-bonus-meta2-text', 'First-come, first-served'),
          },
        ],
        linkText: i18next.t('worldfirst-bonus-reward-link', 'View T&C'),
        linkUrl: LINKS.termsPdf,
        imageUrl: img('bonus_reward_credited.png'),
        imageAlt: i18next.t('worldfirst-bonus-reward-alt-v2', '{{wf}} bonus credited directly to your account', BRAND),
      },
    },

    // ========== §3 Steps（wf-steps-section）==========
    STEPS: {
      heading: i18next.t('worldfirst-steps-heading-v2', '<strong>Simple steps</strong> to get your exclusive offer'),
      cards: [
        {
          num: i18next.t('worldfirst-steps-step1-num', 'Step 1'),
          title: i18next.t('worldfirst-steps-step1-title-v2', 'Create Your {{wf}} Account', BRAND),
          text: i18next.t('worldfirst-steps-step1-text-v2', 'Register through {{cj}} and complete your {{wf}} account verification.', BRAND),
          btnText: i18next.t('worldfirst-steps-step1-btn', 'Create Account'),
          btnUrl: LINKS.register,
          imageUrl: img('step_create_account.png'),
          imageAlt: i18next.t('worldfirst-steps-step1-alt-v2', 'Create your {{wf}} account', BRAND),
        },
        {
          num: i18next.t('worldfirst-steps-step2-num', 'Step 2'),
          title: i18next.t('worldfirst-steps-step2-title-v2', 'Start Using Your {{wf}} Account', BRAND),
          eitherText: i18next.t('worldfirst-steps-step2-either-v2', 'Complete <strong>either ONE</strong> of the following:'),
          options: [
            {
              text: i18next.t('worldfirst-steps-step2-opt1-v3', 'Pay CJ <strong>≥ US$500</strong> via {{wf}}', BRAND),
            },
            {
              text: i18next.t('worldfirst-steps-step2-opt2-v3', 'Spend <strong>≥ US$500</strong> with {{wc}}', BRAND),
            },
          ],
          orText: i18next.t('worldfirst-steps-step2-or', 'OR'),
          btnText: i18next.t('worldfirst-steps-step2-btn-v2', 'Go to {{cj}}', BRAND),
          btnUrl: LINKS.wallet,
          imageUrl: img('step_use_account.png'),
          imageAlt: i18next.t('worldfirst-steps-step2-alt-v2', 'Use {{wf}}', BRAND),
        },
        {
          num: i18next.t('worldfirst-steps-step3-num', 'Step 3'),
          title: i18next.t('worldfirst-steps-step3-title', 'Get $100 Bonus'),
          text: i18next.t('worldfirst-steps-step3-text-v2', 'Your US$100 bonus will be credited directly to your {{wf}} account by the last business day of the following month.', BRAND),
          btnText: i18next.t('worldfirst-steps-step3-btn', 'View T&C'),
          btnUrl: LINKS.termsPdf,
          imageUrl: img('step_get_bonus.png'),
          imageAlt: i18next.t('worldfirst-steps-step3-alt-v2', 'Receive your {{wf}} bonus', BRAND),
        },
      ],
      termsText: i18next.t('worldfirst-steps-terms', 'Terms & Conditions'),
      termsPdfUrl: LINKS.termsPdf,
    },

    // ========== §4 Business（wf-business-section）==========
    BUSINESS: {
      heading: i18next.t('worldfirst-business-heading', 'Global business payments made easy'),
      subtitle: i18next.t('worldfirst-business-subtitle-v2', 'Open up a world of payment options with the funds in your {{wf}} account.', BRAND),
      cards: [
        {
          title: i18next.t('worldfirst-business-card1-title', 'Easy collection'),
          items: [
            i18next.t('worldfirst-business-card1-item1', 'Easy Collection from 130+ marketplaces within one Account'),
            i18next.t('worldfirst-business-card1-item2', 'Make small orders to test the market or bulk purchases to scale rapidly.'),
          ],
          imageUrl: img('business_easy_collection.jpg'),
          imageAlt: i18next.t('worldfirst-business-card1-alt', 'Easy global payment collection'),
        },
        {
          title: i18next.t('worldfirst-business-card2-title', 'Lower fees. More savings'),
          items: [
            i18next.t('worldfirst-business-card2-item1', 'Avoid intermediary bank fees'),
            i18next.t('worldfirst-business-card2-item2', 'Reduce costly transfer fees'),
            i18next.t('worldfirst-business-card2-item3', 'Save on all business expenses, everywhere'),
          ],
          imageUrl: img('business_lower_fees.jpg'),
          imageAlt: i18next.t('worldfirst-business-card2-alt', 'Lower fees and more savings'),
        },
        {
          title: i18next.t('worldfirst-business-card3-title', 'Pay CJ fast and easily'),
          items: [
            i18next.t('worldfirst-business-card3-item1', 'Zero transaction fees'),
            i18next.t('worldfirst-business-card3-item2', 'Instant settlement in full'),
            i18next.t('worldfirst-business-card3-item3', 'One-click payments'),
          ],
          imageUrl: img('business_pay_cj_fast.jpg'),
          imageAlt: i18next.t('worldfirst-business-card3-alt', 'Pay CJ quickly and easily'),
        },
      ],
    },

    // ========== §5 Multi-currency（wf-multi-section）==========
    MULTI: {
      headingLine1: i18next.t('worldfirst-multi-heading-line1', 'Your multi-currency account'),
      headingLine2: i18next.t('worldfirst-multi-heading-line2', 'for global trade – all in one place'),
      cards: [
        {
          title: i18next.t('worldfirst-multi-card1-title', 'Local receiving accounts'),
          text: i18next.t('worldfirst-multi-card1-text-v2', 'Use local account details to receive funds in <strong>20+ currencies</strong> with zero fees. No minimum account balance required.'),
          imageUrl: img('multi_local_receiving_accounts.png'),
          imageAlt: i18next.t('worldfirst-multi-card1-alt', 'Local receiving accounts'),
        },
        {
          title: i18next.t('worldfirst-multi-card2-title', 'Competitive FX rates, 24/7'),
          text: i18next.t('worldfirst-multi-card2-text', 'Lock-in targeted rates using forward contracts and firm orders, up to 24 months.'),
          imageUrl: img('multi_competitive_fx_rates.png'),
          imageAlt: i18next.t('worldfirst-multi-card2-alt', 'Competitive FX rates'),
        },
        {
          title: i18next.t('worldfirst-multi-card3-title', 'Free, easy account setup'),
          text: i18next.t('worldfirst-multi-card3-text', 'Open your multi-currency account entirely online within minutes – no setup or monthly fees.'),
          imageUrl: img('multi_free_account_setup.png'),
          imageAlt: i18next.t('worldfirst-multi-card3-alt', 'Free easy account setup'),
        },
        {
          // 【纠正】原型 L7667 卡4 标题写成与卡1 相同的 'Local receiving accounts'，
          //         但其正文讲的是 "Send payments in ... to 210+ countries/territories"（发款），
          //         与卡1 的"收款"是两件事，判定为复制粘贴残留，按 D7③ 改为 'Global payments'。
          //         单测 CASE-C4 断言 6 张卡标题互不重复、CASE-P2 断言卡4 正文含 'Send payments in'。
          title: i18next.t('worldfirst-multi-card4-title', 'Global payments'),
          text: i18next.t('worldfirst-multi-card4-text-v2', 'Send payments in <strong>100+ currencies</strong> to 210+ countries/territories, with funds typically arriving in hours.'),
          imageUrl: img('multi_global_payments.png'),
          imageAlt: i18next.t('worldfirst-multi-card4-alt', 'Global payments in multiple currencies'),
        },
        {
          title: i18next.t('worldfirst-multi-card5-title', '130+ marketplace collections'),
          text: i18next.t('worldfirst-multi-card5-text-v2', 'Get paid directly from <strong>130+ marketplaces</strong>, and manage all your marketplace earnings in one account.'),
          imageUrl: img('multi_marketplace_collections.png'),
          imageAlt: i18next.t('worldfirst-multi-card5-alt', 'Marketplace collections'),
        },
        {
          title: i18next.t('worldfirst-multi-card6-title', 'Save with card payments'),
          text: i18next.t('worldfirst-multi-card6-text-v3', 'Pay ads, subscriptions, logistics and more with the {{wc}}. Enjoy 0% FX fees in <strong>15 currencies</strong>', BRAND),
          // 【纠正】原型该文案出现两处（卡6 note L7813 + 区块 footer note L7870）。
          //         按 D7③ 只保留卡6 这处——该限制只针对 World Card，卡6 正是讲 World Card 的那张；
          //         放在 footer 会让读者误以为整个多币种账户在美国不可用。单测 CASE-P3 断言全页只出现 1 次。
          note: i18next.t('worldfirst-multi-card6-note-v2', '({{wc}} not supported in US)', BRAND),
          imageUrl: img('multi_card_payments.png'),
          imageAlt: i18next.t('worldfirst-multi-card6-alt-v2', '{{wc}} payments', BRAND),
        },
      ],
      ctaText: i18next.t('worldfirst-multi-cta', 'Sign Up for Free'),
      ctaUrl: LINKS.register,
      // 260818 按用户要求恢复：与卡6 的 note 并存（卡6 那条限定 World Card 这一项，
      // 这条是整个多币种区块的统一声明），此前按 D7③ 误当重复删掉了。
      footerNote: i18next.t('worldfirst-multi-footer-note-v2', '({{wc}} not supported in US)', BRAND),
    },

    // ========== §6 Events 轮播（cj-suggestion-slider）==========
    EVENTS: {
      // 【纠正】原型 L8435 标题为 `Meet  <span> CJdropshipping </span> and <span style="color:#ff0051"> WorldFirst </span> at...`，
      //         含双空格与 span 内侧空格，且用了内联 style；此处按 5 段拆分、空格归一，着色交给
      //         .cj-suggestion-title-em 类（内联 style 无法进 :global 体系）。
      titlePre: i18next.t('worldfirst-events-title-pre', 'Meet'),
      titleEm1: i18next.t('worldfirst-events-title-em1-v2', '{{cj}}', BRAND),
      titleMid: i18next.t('worldfirst-events-title-mid', 'and'),
      titleEm2: i18next.t('worldfirst-events-title-em2-v2', '{{wf}}', BRAND),
      titlePost: i18next.t('worldfirst-events-title-post', 'at Our Offline Events'),
      prevAria: i18next.t('worldfirst-events-prev-aria', 'Previous event'),
      nextAria: i18next.t('worldfirst-events-next-aria', 'Next event'),
      // %n% 由 EventsSlider 按卡片序号替换；原型 alt 为 'CJdropshipping suggestion N'，
      // 此处改为更贴合内容的描述（线下活动图），对 SEO/无障碍更有意义。
      // 编号在译文**之外**拼接（见 EventsSlider 的 alt）：占位符活不过翻译管线
      //（%x% 实测完好率 17.3%），而 alt 里的序号本就无需翻译。
      slideAlt: i18next.t('worldfirst-events-slide-alt-v3', '{{cj}} and {{wf}} offline event', BRAND),
      slides: [
        { num: '01', imageUrl: img('event_offline01.jpg') },
        { num: '02', imageUrl: img('event_offline02.jpg') },
        { num: '03', imageUrl: img('event_offline03.jpg') },
        { num: '04', imageUrl: img('event_offline04.jpg') },
        { num: '05', imageUrl: img('event_offline05.jpg') },
        { num: '06', imageUrl: img('event_offline06.jpg') },
        { num: '07', imageUrl: img('event_offline07.jpg') },
        { num: '08', imageUrl: img('event_offline08.jpg') },
      ],
    },

    // ========== §7 FAQ（cjwf-premium-faq）==========
    FAQ: {
      title: i18next.t('worldfirst-faq-title-v3', 'Everything You Need to Know About <strong>{{wf}}</strong>', BRAND),
      desc: i18next.t('worldfirst-faq-desc-v2', 'Find answers about the exclusive US$100 bonus, {{wf}} payments, receiving accounts, FX management and account security.', BRAND),
      sideLabel: i18next.t('worldfirst-faq-side-label-v2', 'CJ × {{wf}}', BRAND),
      sideTitle: i18next.t('worldfirst-faq-side-title-v2', 'Simple answers for <strong>smarter payments.</strong>'),
      sideText: i18next.t('worldfirst-faq-side-text-v2', 'Explore the most common questions from {{cj}} users about {{wf}} accounts, payments and promotional rewards.', BRAND),
      sideStat: i18next.t('worldfirst-faq-side-stat', 'Common questions'),
      bgImage: img('faq_bg.jpg'),
      items: [
        {
          num: 'Q01',
          q: i18next.t('worldfirst-faq-q1', 'Who is eligible for the US$100 bonus?'),
          paras: [
            {
              text: i18next.t('worldfirst-faq-q1-a1-v3', 'This offer is exclusive to <strong>{{cj}} users who are new to {{wf}}.</strong>', BRAND),
            },
            {
              text: i18next.t('worldfirst-faq-q1-a2-v3', 'Existing {{wf}} customers are not eligible for the <strong>US$100 bonus</strong>, but can still enjoy cashback according to the applicable regional mechanism.', BRAND),
              // 原型此处的强调是 <span class="cjwf-premium-highlight">（粉色 + 750 字重），全页仅此一处。
              // 词条里统一只放 <strong>（带 class 的标签在翻译管线属性保留率仅 50.6%，不能把配色交给机翻），
              // 故用这个**不参与翻译**的样式钩子把粉色加回来，配套规则见 index.less 的 .cjwf-premium-answer-p--pink。
              pClass: 'cjwf-premium-answer-p--pink',
            },
          ],
        },
        {
          num: 'Q02',
          q: i18next.t('worldfirst-faq-q2', 'How do I receive the US$100 bonus?'),
          paras: [
            {
              text: i18next.t('worldfirst-faq-q2-a1-v3', 'Register through the <strong>{{cj}} exclusive {{wf}} link</strong>, complete your account verification, and complete one of the following qualifying tasks.', BRAND),
            },
          ],
          promoLabel: i18next.t('worldfirst-faq-q2-promo-label', 'Qualifying Tasks'),
          tasks: [
            {
              num: i18next.t('worldfirst-faq-q2-task1-num', 'Option 01'),
              title: i18next.t('worldfirst-faq-q2-task1-title', 'Pay CJ ≥ US $500'),
              text: i18next.t('worldfirst-faq-q2-task1-text-v2', 'Get a $100 USD bonus when you pay CJ ≥ $500 via {{wf}}!', BRAND),
            },
            {
              num: i18next.t('worldfirst-faq-q2-task2-num', 'Option 02'),
              title: i18next.t('worldfirst-faq-q2-task2-title-v2', '{{wc}} Spend ≥ US $500', BRAND),
              text: i18next.t('worldfirst-faq-q2-task2-text-v2', 'Get a $100 USD bonus when your {{wc}} cumulative spending reaches ≥ $500', BRAND),
            },
          ],
          parasAfter: [
            {
              text: i18next.t('worldfirst-faq-q2-a2-v2', 'The <strong>US$100 bonus</strong> will be credited to your account by the last business day of the following month.'),
            },
          ],
          methods: [
            {
              icon: '01',
              title: i18next.t('worldfirst-faq-q2-method1-title-v2', '{{wf}} Pay', BRAND),
              text: i18next.t('worldfirst-faq-q2-method1-text-v2', 'Go to the {{cj}} checkout page, select {{wf}} as your payment method, and complete payment using your {{wa}} balance.', BRAND),
            },
            {
              icon: '02',
              title: i18next.t('worldfirst-faq-q2-method2-title-v2', '{{wd}}', BRAND),
              text: i18next.t('worldfirst-faq-q2-method2-text-v2', 'Log in to {{wf}}, go to Payments → {{wd}}, search for {{cj}}, and complete your payment. Transfers are free and instant.(Available in select regions only. {{wf}} reserves the right of final interpretation.)', BRAND),
            },
            {
              icon: '03',
              title: i18next.t('worldfirst-faq-q2-method3-title-v2', '{{wc}}', BRAND),
              text: i18next.t('worldfirst-faq-q2-method3-text-v2', 'Apply for a {{wc}} and use it for business expenses including advertising, software, travel, shipping and logistics.', BRAND),
            },
          ],
        },
        {
          num: 'Q03',
          q: i18next.t('worldfirst-faq-q3', 'Is there a time limit to reach the US$500 spending threshold?'),
          paras: [
            {
              text: i18next.t('worldfirst-faq-q3-a-v3', 'Yes. You need to register for a {{wf}} account before <strong>December 31, 2026</strong> and complete the qualifying task by <strong>January 31, 2027</strong>', BRAND),
            },
          ],
        },
        {
          num: 'Q04',
          q: i18next.t('worldfirst-faq-q4-v2', 'How can I top up my {{wf}} Account?', BRAND),
          paras: [
            { text: i18next.t('worldfirst-faq-q4-a1-v2', 'You can top up your {{wa}} using funds from your own bank account to make FX conversions and payouts to another party abroad.', BRAND) },
            {
              text: i18next.t('worldfirst-faq-q4-a2-v3', '<strong>Please note:</strong> the bank account must have the same owner as the {{wf}} account.', BRAND),
            },
            {
              text: i18next.t('worldfirst-faq-q4-a3-v3', 'For detailed steps, please follow the <strong>“How do I top up my {{wa}}?”</strong> guide.', BRAND),
            },
          ],
        },
        {
          num: 'Q05',
          q: i18next.t('worldfirst-faq-q5', 'Who can I receive payments from with Receiving Accounts?'),
          paras: [
            { text: i18next.t('worldfirst-faq-q5-a1', 'You can receive payments from several sources, including:') },
          ],
          list: [
            { text: i18next.t('worldfirst-faq-q5-item1', 'Online marketplaces such as Amazon') },
            { text: i18next.t('worldfirst-faq-q5-item2', 'Payment service providers and gateways such as Stripe') },
            { text: i18next.t('worldfirst-faq-q5-item3', 'Your company\'s or your own bank account') },
            { text: i18next.t('worldfirst-faq-q5-item4', 'Freelancer platforms such as Upwork and Malt, if you are a freelancer') },
          ],
          parasAfter: [
            { text: i18next.t('worldfirst-faq-q5-a2', 'As a sole proprietor, you can receive payments from approved marketplaces, payment gateways and your own personal bank account.') },
            { text: i18next.t('worldfirst-faq-q5-a3', 'If you\'re a business, you may receive incoming payments from approved marketplaces, payment service providers and your own bank account.') },
            { text: i18next.t('worldfirst-faq-q5-a4-v2', '{{wf}} may occasionally request additional information before releasing a payment in order to protect your account against fraud. Supporting documents such as invoices or contracts may be required.', BRAND) },
          ],
        },
        {
          num: 'Q06',
          q: i18next.t('worldfirst-faq-q6-v2', 'How can I make payments to another {{wf}} account?', BRAND),
          paras: [
            { text: i18next.t('worldfirst-faq-q6-a-v2', 'You can make free and instant payments to other {{wf}} customers.', BRAND) },
          ],
          ordered: [
            {
              text: i18next.t('worldfirst-faq-q6-step1-v2', 'Click <strong>Payments</strong> and select <strong>Send & Withdraw</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step2-v3', 'Select <strong>Single Payee</strong> and <strong>{{wa}}</strong>', BRAND),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step3-v3', 'Enter the payee\'s {{wa}} receiving ID, including the prefix <strong>WF</strong>', BRAND),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step4-v2', 'Enter the optional payment reference and click <strong>Next</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step5-v2', 'Select your payment currency, enter the payment amount and click <strong>Next</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step6-v2', 'Confirm the payment using two-factor authentication <strong>(2FA)</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step7-v2', 'Review the payment details and select <strong>Submit</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q6-step8-v2', 'View the completed payment under <strong>Statements</strong>'),
            },
          ],
        },
        {
          num: 'Q07',
          q: i18next.t('worldfirst-faq-q7', 'How long will my payments take?'),
          paras: [
            { text: i18next.t('worldfirst-faq-q7-a1', 'Payment speed depends on the currency, beneficiary\'s bank and country, and transaction size.') },
            { text: i18next.t('worldfirst-faq-q7-a2', 'The following currency and destination combinations are usually processed within one business day:') },
          ],
          countries: [
            i18next.t('worldfirst-faq-q7-country1', 'EUR → Europe'),
            i18next.t('worldfirst-faq-q7-country2', 'GBP → UK'),
            i18next.t('worldfirst-faq-q7-country3', 'USD → USA'),
            i18next.t('worldfirst-faq-q7-country4', 'SGD → Singapore'),
            i18next.t('worldfirst-faq-q7-country5', 'HKD / USD → Hong Kong'),
            i18next.t('worldfirst-faq-q7-country6', 'AUD → Australia'),
            i18next.t('worldfirst-faq-q7-country7', 'NZD → New Zealand'),
          ],
          daysText: i18next.t('worldfirst-faq-q7-days', '1 day'),
          parasAfter: [
            {
              text: i18next.t('worldfirst-faq-q7-a3-v2', 'For other currency and country combinations, please allow approximately <strong>1–2 additional business days</strong>. The beneficiary\'s bank may sometimes require an additional business day to credit the funds.'),
            },
          ],
        },
        {
          num: 'Q08',
          q: i18next.t('worldfirst-faq-q8', 'How can I check the status of my FX trades?'),
          paras: [
            { text: i18next.t('worldfirst-faq-q8-a', 'To see the status of your FX trades:') },
          ],
          ordered: [
            {
              text: i18next.t('worldfirst-faq-q8-step1-v2', 'Go to <strong>Payments</strong> in the top navigation.'),
            },
            {
              text: i18next.t('worldfirst-faq-q8-step2-v2', 'Select <strong>Transaction Management</strong>'),
            },
            {
              text: i18next.t('worldfirst-faq-q8-step3-v2', 'Select <strong>FX Trades</strong>'),
            },
            { text: i18next.t('worldfirst-faq-q8-step4', 'View trades that are settled, open, cancelled or processing.') },
          ],
        },
        {
          num: 'Q09',
          q: i18next.t('worldfirst-faq-q9-v2', 'Is my money safe with {{wf}}?', BRAND),
          security: i18next.t('worldfirst-faq-q9-a1-em-v2', 'Yes. {{wf}} is part of Ant Group and holds 70+ regulatory licences globally.', BRAND),
          parasAfter: [
            { text: i18next.t('worldfirst-faq-q9-a2-v2', 'Your money is protected through {{wf}}\'s security, regulatory and compliance framework.', BRAND) },
          ],
        },
      ],
    },

    // ========== §8 底部 CTA（cjwf-cta）==========
    CTA: {
      title: i18next.t('worldfirst-cta-title-v2', 'Why Choose {{cj}} + {{wf}}?', BRAND),
      // 【合成一条】原型 .cjwf-cta-desc 是**一个 <p>**，里面依次是 strong/正文/strong/正文/strong。
      // 早先拆成 desc1+desc2 两条，渲染出来是两个相邻 Fragment，首尾各有文本节点 ——
      // 本仓 SSR 产物剥掉了 HTML 注释，React 靠 `<!-- -->` 分隔相邻文本节点，剥掉后 hydrate 会报
      // `Text content did not match`（260818 实测）。合成一条后既消除相邻节点，
      // 也让译者拿到的是**完整的一句**而不是两个半句，更利于调整语序。
      desc: i18next.t('worldfirst-cta-desc-v3', '<strong>{{cj}}</strong> powers your supply chain. <strong>{{wf}}</strong> powers your finances. Together, we help you manage funds more efficiently and cut unnecessary costs — so you can focus on what matters: <strong>growing your business.</strong>', BRAND),
      primaryText: i18next.t('worldfirst-cta-btn-primary', 'Get Started'),
      primaryUrl: LINKS.register,
      secondaryText: i18next.t('worldfirst-cta-btn-secondary', 'Contact Us'),
      secondaryUrl: LINKS.contact,
      logoCj: img('logo_cjdropshipping.svg'),
      logoCjAlt: i18next.t('worldfirst-cta-logo-cj-alt-v2', '{{cj}}', BRAND),
      logoWf: img('logo_worldfirst.svg'),
      logoWfAlt: i18next.t('worldfirst-cta-logo-wf-alt-v2', '{{wf}}', BRAND),
    },
  };
}

module.exports = { getConstants: getConstants, LINKS: LINKS };
